import { CustomQueryStringParameterItems } from 'libs/contentful/types';
import { PageContextValue } from 'contexts/pageContextValue';

/**
 * Returns the custom query string parameter items for use in client components.
 * Uses server-resolved items when present (variant-aware); otherwise falls back to
 * section baseline or inline collection. Safe to call from 'use client' components—
 * does not import or use server-only code.
 */
export function getCustomQueryStringParametersItemsForClient(
  page: PageContextValue | undefined,
): CustomQueryStringParameterItems[] {
  if (!page) return [];
  if (page.resolvedCustomQueryStringParametersItems?.length) {
    return page.resolvedCustomQueryStringParametersItems;
  }
  const sectionItems = page.customQueryStringParameters?.customQueryStringParametersCollection?.items ?? [];
  const inlineItems = page.customQueryStringParametersCollection?.items ?? [];
  return sectionItems.length ? sectionItems : inlineItems;
}
